import { useContext } from "react";
import { AirdropContext, MetricsContext } from "@/src/context";

export const useMetrics = () => useContext(MetricsContext);
export const useAirdrop = () => useContext(AirdropContext);